import React, { useEffect, useState } from 'react';
import { useStore } from 'hooks';
import { DirectionService } from 'services';
import Menu from 'components/menu';
import Table from 'components/table';
import Actions from 'components/table/actions';
import Modal from 'components/modal';
import Direction from 'components/modal/direction';
import { Input } from 'components/ui/form';
import styles from './directions.module.scss';

const DEFAULT_LIMIT = 20;

const DirectionsPage = () => {
  const { reload, setUser, setLoading, setReload } = useStore();
  const [data, setData] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(DEFAULT_LIMIT);
  const [search, setSearch] = useState('');
  const [edit, setEdit] = useState(null);
  const [modal, setModal] = useState(false);

  useEffect(() => {
    let cancelled = false;

    const fetchDirections = async () => {
      setLoading(true);
      try {
        const query = { page, limit };
        if (search.trim()) query.search = search.trim();
        const response = await new DirectionService({ setUser }).getDirections(query);
        if (cancelled || !response) return;
        setData(response.items || []);
        setCount(response.count || 0);
      } finally {
        setLoading(false);
      }
    };

    fetchDirections();
    return () => { cancelled = true; };
  }, [reload, page, limit, search, setLoading, setUser]);

  const closeModal = (shouldReload = false) => {
    setModal(false);
    setEdit(null);
    if (shouldReload) setReload();
  };

  const deleteDirection = async (direction) => {
    if (!window.confirm(`Удалить направление «${direction.name}»?`)) return;
    setLoading(true);
    try {
      await new DirectionService({ setUser }).deleteDirection(direction.id);
      setReload();
    } finally {
      setLoading(false);
    }
  };

  const cells = [{
    name: 'ID',
    nowrap: true,
    renderField: 'id',
  }, {
    name: 'Название',
    renderField: 'name',
  }, {
    name: 'Код',
    nowrap: true,
    renderField: 'code',
  }, {
    name: '',
    right: true,
    nowrap: true,
    onRender: item => (
      <Actions data={[{
        name: 'edit',
        title: 'Открыть',
        onClick: () => { setEdit(item); setModal(true); },
      }, {
        name: 'cancel',
        title: 'Удалить',
        onClick: () => deleteDirection(item),
      }]} />
    ),
  }];

  return (
    <>
      <div className={styles.menu}><Menu onAdd={() => setModal(true)} /></div>
      <div className={styles.search}>
        <Input
          type="text"
          value={search}
          onChange={event => { setSearch(event.target.value); setPage(0); }}
          placeholder="Поиск по названию, коду"
        />
      </div>
      <div className={styles.table}>
        <Table
          cells={cells}
          data={data}
          count={count}
          page={page}
          limit={limit}
          onPageChange={({ selected }) => setPage(selected)}
          onLimitChange={newLimit => { setLimit(newLimit); setPage(0); }}
        />
      </div>
      {modal && (
        <Modal closeBackground={false} onClose={closeModal}>
          <Direction edit={edit} onClose={closeModal} />
        </Modal>
      )}
    </>
  );
};

export default DirectionsPage;
